<template>
  <div id="account-dialog" class="custom-modal">
    <div class="modal-body no-footer">
      <transition name="el-fade-in" mode="out-in">
        <el-row>
          <el-tabs v-model="activeTab" @tab-click="handleClick" stretch>
            <el-tab-pane :label="$t('account_settings.profile.title')" name="1">
              <div class="container-inner">
                <div class="info-card">
                  <i class="fa fa-eye"></i>
                  <span v-if="accountform.showMeOnAPP == true">{{ $t("account_settings.profile.visibleDesc") }}</span>
                  <span v-if="accountform.showMeOnAPP == false">{{ $t("account_settings.profile.invisibleDesc") }}</span>
                </div>

                <div class="profile-picture-container">
                  <div class="profile-picture" @click="openFileChanged" :style="'background-image: url(' + $imageus + accountform.image + '?width=184&height=184&mode=cover)'"></div>

                  <label>
                    {{ $t("change_image") }}
                    <i class="fa fa-camera"></i>
                    <input type="file" id="file" ref="file" v-on:change="filePicked()" />
                  </label>
                </div>

                <div class="section-settings">
                  <div class="section-setting-item big">
                    <div class="setting-icon">
                      <div class="setting-icon-box">
                        <i class="fas fa-check"></i>
                      </div>
                    </div>

                    <div class="setting-title">{{ $t("accountSettings.settings") }}</div>
                    <div class="setting-info"></div>
                  </div>
                  <div class="section-setting-item">
                    <div class="setting-icon">
                      <div class="setting-icon-box">
                        <i class="fas fa-eye"></i>
                      </div>
                    </div>
                    <div class="setting-title">
                      <span v-if="accountform.showMeOnAPP == true">
                        <b>{{ $t("account_settings.profile.title") }}</b>
                        : {{ $t("account_settings.profile.visible") }}
                      </span>
                      <span v-if="accountform.showMeOnAPP == false">
                        <b>{{ $t("account_settings.profile.title") }}</b>
                        : {{ $t("account_settings.profile.invisible") }}
                      </span>
                    </div>
                    <div class="setting-info">
                      <el-switch v-model="accountform.showMeOnAPP" @change="toggleAccountVisible"></el-switch>
                    </div>
                  </div>
                  <div class="section-setting-item">
                    <div class="setting-icon">
                      <div class="setting-icon-box">
                        <i class="fas fa-clock"></i>
                      </div>
                    </div>
                    <div class="setting-title">
                      <span>{{ $t("account_settings.profile.show_busy") }}</span>
                    </div>
                    <div class="setting-info">
                      <el-switch v-model="accountform.showMeBusy" @change="toggleAccountVisible"></el-switch>
                    </div>
                  </div>
                </div>
                <div class="custom-section-area">
                  <div class="custom-section-title">
                    <div class="custom-section-icon-box">
                      <div class="section-box-icon">
                        <i class="fas fa-info-circle"></i>
                      </div>
                    </div>
                    <span>{{ $t("accountSettings.information") }}</span>
                  </div>
                  <div class="custom-section-body">
                    <div class="information-form">
                      <div class="information-form-input">
                        <label>{{ $t("accountSettings.company") }}</label>
                        <el-input placeholder="..." v-model="profileform.company"></el-input>
                        <span class="text-danger">{{ $errorMessage("contactInfo.Company", validationErrors) }}</span>
                      </div>
                      <div class="information-form-input">
                        <label>{{ $t("accountSettings.title") }}</label>
                        <el-input placeholder="..." v-model="profileform.title"></el-input>
                        <span class="text-danger">{{ $errorMessage("contactInfo.Title", validationErrors) }}</span>
                      </div>
                      <div class="information-form-input">
                        <label>{{ $t("account_settings.profile.email") }}</label>
                        <el-input placeholder="..." v-model="profileform.email"></el-input>
                        <span class="text-danger">{{ $errorMessage("contactInfo.Email", validationErrors) }}</span>
                      </div>
                      <div class="information-form-input">
                        <label>{{ $t("settings.cellPhone") }}</label>
                        <vue-phone-number-input
                          v-model="profileform.cellPhone"
                          ref="contactCellPhoneInput"
                          :translations="{
                            countrySelectorLabel: $t('settings.country'),
                            countrySelectorError: $t('settings.country_error'),
                            phoneNumberLabel: $t('settings.phone'),
                            example: $t('settings.example')
                          }"
                          size="small"
                          default-country-code="TR"
                        />
                        <span class="text-danger">{{ $errorMessage("contactInfo.CellPhone", validationErrors) }}</span>
                      </div>
                      <div class="information-form-input">
                        <label>{{ $t("settings.phone") }}</label>
                        <vue-phone-number-input
                          v-model="profileform.phone"
                          ref="contactPhoneInput"
                          :translations="{
                            countrySelectorLabel: $t('settings.country'),
                            countrySelectorError: $t('settings.country_error'),
                            phoneNumberLabel: $t('settings.phone'),
                            example: $t('settings.example')
                          }"
                          size="small"
                          default-country-code="TR"
                        />
                        <span class="text-danger">{{ $errorMessage("contactInfo.Phone", validationErrors) }}</span>
                      </div>
                      <div class="information-form-input">
                        <label>{{ $t("settings.about") }}</label>
                        <el-input placeholder="..." v-model="profileform.about"></el-input>
                        <span class="text-danger">{{ errorMessage("about") }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="custom-section-footer">
                    <el-button type="primary" :loading="loading == 'saveProfile'" :disabled="loading == 'saveProfile'" @click="saveProfile">{{ $t("save") }}</el-button>
                  </div>
                </div>
                <div class="custom-section-area">
                  <div class="custom-section-header">
                    <div class="custom-section-title">
                      <div class="custom-section-icon-box">
                        <div class="section-box-icon">
                          <i class="fas fa-briefcase"></i>
                        </div>
                      </div>
                      <span>{{ $t("accountSettings.work") }}</span>
                    </div>
                    <el-button
                      type="primary"
                      size="mini"
                      @click="
                        addJobModal = true;
                        addJobId = null;
                      "
                      round
                    >
                      {{ $t("add") }}
                    </el-button>
                  </div>
                  <div class="custom-section-body" v-if="user.jobs.length > 0">
                    <div v-for="(item, index) in user.jobs" :key="item.id + index" class="custom-card">
                      <div class="custom-card-header">
                        <div class="md-title" style="margin: 0; font-size: 18px;">
                          {{ item.firmName }}
                        </div>
                        <div class="md-subhead bold">{{ item.position }}</div>
                        <div class="md-subhead">
                          {{ moment(item.dateStart).format("D MMMM YYYY") }} -
                          {{ item.dateEnd == null || item.dateEnd == "" ? $t("settings.no_end") : moment(item.dateEnd).format("D MMMM YYYY") }}
                        </div>
                      </div>

                      <el-dropdown class="action" trigger="click">
                        <span class="el-dropdown-link">
                          <i class="fas fa-ellipsis-v"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                          <el-dropdown-item
                            @click.native="
                              addJobId = item.id;
                              addJobModal = true;
                            "
                          >
                            {{ $t("settings.edit") }}
                          </el-dropdown-item>
                          <el-dropdown-item @click.native="deleteJob(item.id)">
                            {{ $t("settings.remove") }}
                          </el-dropdown-item>
                        </el-dropdown-menu>
                      </el-dropdown>
                    </div>
                  </div>
                </div>
                <div class="custom-section-area">
                  <div class="custom-section-header">
                    <div class="custom-section-title">
                      <div class="custom-section-icon-box">
                        <div class="section-box-icon">
                          <i class="fas fa-graduation-cap"></i>
                        </div>
                      </div>
                      <span>{{ $t("settings.school_title") }}</span>
                    </div>
                    <el-button
                      type="primary"
                      size="mini"
                      @click="
                        addSchoolId = null;
                        addSchoolModal = true;
                      "
                      round
                    >
                      {{ $t("add") }}
                    </el-button>
                  </div>
                  <div class="custom-section-body" v-if="user.schools.length > 0">
                    <div v-for="item in user.schools" :key="item.id" class="custom-card">
                      <div class="custom-card-header">
                        <div class="md-title" style="margin: 0; font-size: 18px;">
                          {{ item.title }}
                        </div>
                        <div class="md-subhead bold">{{ item.department }}</div>
                        <div class="md-subhead">
                          {{ moment(item.dateStart).format("D MMMM YYYY") }} -
                          {{ item.dateEnd == null || item.dateEnd == "" ? $t("settings.no_end") : moment(item.dateEnd).format("D MMMM YYYY") }}
                        </div>
                      </div>

                      <el-dropdown class="action" trigger="click">
                        <span class="el-dropdown-link">
                          <i class="fas fa-ellipsis-v"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                          <el-dropdown-item
                            @click.native="
                              addSchoolId = item.id;
                              addSchoolModal = true;
                            "
                          >
                            {{ $t("settings.edit") }}
                          </el-dropdown-item>
                          <el-dropdown-item @click.native="deleteSchool(item.id)">{{ $t("settings.remove") }}</el-dropdown-item>
                        </el-dropdown-menu>
                      </el-dropdown>
                    </div>
                  </div>
                </div>
                <div class="custom-section-area">
                  <div class="custom-section-header">
                    <div class="custom-section-title">
                      <div class="custom-section-icon-box">
                        <div class="section-box-icon">
                          <i class="fas fa-globe-americas"></i>
                        </div>
                      </div>
                      <span>{{ $t("accountSettings.language") }}</span>
                    </div>
                    <el-button
                      type="primary"
                      size="mini"
                      @click="
                        addLanguageId = null;
                        addLanguageModal = true;
                      "
                      round
                    >
                      {{ $t("add") }}
                    </el-button>
                  </div>
                  <div class="custom-section-body" v-if="user.languages.length > 0">
                    <div v-for="item in user.languages" :key="item.id" class="custom-card">
                      <div class="custom-card-header">
                        <div v-if="$store.getters.getUserLanguages.length > 0" class="md-title" style="margin: 0; font-size: 18px;">
                          {{ $store.getters.getUserLanguages.find(x => x.id === item.language.id).title  }}
                        </div>
                        <div class="md-subhead bold">
                          {{ $t("accountSettings.speaking") }}
                          {{ getEnumsDisplay("UserLanguageLevel", item.speaking) }}
                        </div>
                        <div class="md-subhead bold">
                          {{ $t("accountSettings.writing") }}
                          {{ getEnumsDisplay("UserLanguageLevel", item.writing) }}, {{ $t("accountSettings.reading") }}
                          {{ getEnumsDisplay("UserLanguageLevel", item.reading) }}
                        </div>
                      </div>

                      <el-dropdown class="action" trigger="click">
                        <span class="el-dropdown-link">
                          <i class="fas fa-ellipsis-v"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                          <el-dropdown-item
                            @click.native="
                              addLanguageId = item.id;
                              addLanguageModal = true;
                            "
                          >
                            {{ $t("settings.edit") }}
                          </el-dropdown-item>
                          <el-dropdown-item @click.native="deleteLanguage(item.id)">{{ $t("settings.remove") }}</el-dropdown-item>
                        </el-dropdown-menu>
                      </el-dropdown>
                    </div>
                  </div>
                </div>
                <div class="custom-section-area" style="margin-bottom:1rem">
                  <div class="custom-section-header">
                    <div class="custom-section-title">
                      <div class="custom-section-icon-box">
                        <div class="section-box-icon">
                          <i class="fas fa-star"></i>
                        </div>
                      </div>
                      <span>{{ $t("settings.interest_title") }}</span>
                    </div>
                    <el-button
                      type="primary"
                      size="mini"
                      @click="
                        addUpdateInterestForm = !addUpdateInterestForm;
                        searchTerm = null;
                      "
                      round
                    >
                      {{ $t("add") }}
                    </el-button>
                  </div>
                  <div class="custom-section-body" style="display:flex;gap:10px;flex-wrap:wrap;" v-if="user.interests.length > 0 || addUpdateInterestForm">
                    <el-tag :closable="true" @close="toggleInterest({ title: item })" effect="dark" v-for="(item, interestIndex) in user.interests" type="primary" :key="interestIndex + '-interest-index'">{{ item }}</el-tag>
                    <div class="add-panel-container" v-if="addUpdateInterestForm">
                      <el-form :label-position="'top'" label-width="100px">
                        <el-form-item :label="$t('settings.search_interest')">
                          <el-input prefix-icon="el-icon-search" v-model="searchTerm" @clear="searchTerm = null" :clearable="true"></el-input>
                        </el-form-item>
                      </el-form>

                      <div class="chips-container">
                        <el-tag v-for="item in interests" :key="item.id + '-insterest-new-list'" @click="toggleInterest(item)" effect="dark" :type="user.interests.some(x => x == item.title) ? 'primary' : 'warning'">{{ item.title }}</el-tag>
                      </div>
                    </div>

                    <div class="form-confirm" v-if="addUpdateInterestForm">
                      <el-button
                        v-if="addUpdateInterestForm"
                        type="danger"
                        @click="
                          addUpdateInterestForm = !addUpdateInterestForm;
                          searchTerm = null;
                        "
                        round
                      >
                        {{ $t("close") }}
                      </el-button>
                    </div>
                  </div>
                </div>
              </div>
            </el-tab-pane>

            <el-tab-pane :label="$t('account_settings.account.title')" name="2">
              <div class="container-inner">
                <div class="info-card">
                  <i>
                    <i class="badge-check-icon"></i>
                  </i>
                  <span>
                    {{
                      $t("account_settings.account.description", {
                        date: $i18n.locale == "tr" ? moment(this.$store.state.user.updateDate).format("DD MMMM YYYY") : moment(this.$store.state.user.updateDate).format("LL")
                      })
                    }}
                  </span>
                </div>
                <div class="custom-section-area">
                  <div class="custom-section-title">
                    <div class="custom-section-icon-box">
                      <div class="section-box-icon">
                        <i class="fas fa-info-circle"></i>
                      </div>
                    </div>
                    <span>{{ $t("accountSettings.account") }}</span>
                  </div>
                  <div class="custom-section-body">
                    <div class="information-form">
                      <div class="information-form-input">
                        <label>{{ $t("register.firstName") }}</label>
                        <el-input placeholder="..." v-model="accountform.firstName"></el-input>
                        <span class="text-danger">{{ errorMessage("firstName") }}</span>
                      </div>
                      <div class="information-form-input">
                        <label>{{ $t("register.lastName") }}</label>
                        <el-input placeholder="..." v-model="accountform.lastName"></el-input>
                        <span class="text-danger">{{ errorMessage("lastName") }}</span>
                      </div>
                      <div class="information-form-input">
                        <label>{{ $t("register.email") }}</label>
                        <el-input placeholder="..." v-model="accountform.email"></el-input>
                        <span class="md-error" style="color:#505763;" v-if="$store.state.user.emailConfirmed == false && confirmEmailForm == false">
                          <i style="color:#A63326" class="fa fa-times-circle"></i>
                          {{ $t("email_not_confirmed") }}
                          <a style="cursor:pointer;" @click="sendEmailCode">{{ $t("confirm_now") }}</a>
                        </span>
                        <span class="md-error" style="color:#505763;" v-if="$store.state.user.emailConfirmed">
                          <i style="color:#268EA6;" class="fa fa-check-circle"></i>
                          {{ $t("email_confirmed") }}
                        </span>
                        <div v-if="confirmEmailForm" class="account-confirmation-section">
                          <div class="information-form">
                            <div class="information-form-input">
                              <label>{{ $t("write_key") }}</label>
                              <el-input v-model="emailKey"><i slot="suffix" class="el-input__icon fas fa-user-shield"></i></el-input>
                              <span class="md-error">{{ errorMessage("emailKey") }}</span>
                            </div>
                          </div>
                          <el-button type="primary" class="mt-auto" @click="confirmEmail">{{ $t("confirm") }}</el-button>
                        </div>
                        <span class="text-danger">{{ errorMessage("email") }}</span>
                      </div>
                      <div class="information-form-input">
                        <label>{{ $t("settings.cellPhone") }}</label>
                        <vue-phone-number-input
                          v-model="accountform.phoneNumber"
                          ref="phoneInput2"
                          :translations="{
                            countrySelectorLabel: $t('settings.country'),
                            countrySelectorError: $t('settings.country_error'),
                            phoneNumberLabel: $t('settings.phone'),
                            example: $t('settings.example')
                          }"
                          size="small"
                          default-country-code="TR"
                        />
                        <span class="md-error" style="color:#505763;" v-if="$store.state.user.phoneNumberConfirmed == false && confirmPhoneForm == false">
                          <i style="color:#A63326" class="fa fa-times-circle"></i>
                          {{ $t("phone_not_confirmed") }}
                          <a style="cursor:pointer;" @click="sendPhoneCode">{{ $t("confirm_now") }}</a>
                        </span>
                        <span class="md-error" style="color:#505763;" v-if="$store.state.user.phoneNumberConfirmed">
                          <i style="color:#268EA6;" class="fa fa-check-circle"></i>
                          {{ $t("phone_confirmed") }}
                        </span>
                        <div v-if="confirmPhoneForm" class="account-confirmation-section">
                          <div class="information-form">
                            <div class="information-form-input">
                              <label>{{ $t("write_key") }}</label>
                              <el-input v-model="phoneKey" v-mask="'######'"><i slot="suffix" class="el-input__icon fas fa-user-shield"></i></el-input>
                              <span class="text-danger">{{ errorMessage("phoneKey") }}</span>
                            </div>
                          </div>
                          <el-button type="primary" @click="confirmPhone">{{ $t("confirm") }}</el-button>
                        </div>
                        <span class="text-danger">{{ errorMessage("phoneNumber") }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="custom-section-footer">
                    <el-button type="primary" :loading="loading == 'saveAccount'" :disabled="loading == 'saveAccount'" @click="saveAccount">{{ $t("save") }}</el-button>
                  </div>
                </div>
                <div class="section-settings">
                  <div class="section-setting-item big">
                    <div class="setting-icon">
                      <div class="setting-icon-box">
                        <i class="fas fa-bell"></i>
                      </div>
                    </div>
                    <div class="setting-title">{{ $t("accountSettings.notifications") }}</div>
                    <div class="setting-info"></div>
                  </div>
                  <div class="section-setting-item">
                    <div class="setting-icon">
                      <div class="setting-icon-box">
                        <i class="fas fa-bullhorn"></i>
                      </div>
                    </div>
                    <div class="setting-title" style="display:flex;gap:5px; align-items:center;">
                      <span>{{ $t("accountSettings.eventNotifications") }}</span>
                    </div>
                    <div class="setting-info">
                      <el-switch v-model="user.eventNotifications" @change="toggleNotification"></el-switch>
                    </div>
                  </div>
                  <div class="section-setting-item">
                    <div class="setting-icon">
                      <div class="setting-icon-box">
                        <i class="fas fa-users"></i>
                      </div>
                    </div>
                    <div class="setting-title" style="display:flex;align-items:center;gap:5px;">
                      <span>{{ $t("accountSettings.contactNotifications") }}</span>
                    </div>
                    <div class="setting-info">
                      <el-switch v-model="user.peopleNotifications" @change="toggleNotification"></el-switch>
                    </div>
                  </div>
                  <div class="section-setting-item">
                    <div class="setting-icon">
                      <div class="setting-icon-box">
                        <i class="fas fa-comments"></i>
                      </div>
                    </div>
                    <div class="setting-title" style="display:flex;align-items:center;gap:5px;">
                      <span>{{ $t("accountSettings.messageNotifications") }}</span>
                    </div>
                    <div class="setting-info">
                      <el-switch v-model="user.messageNotifications" @change="toggleNotification"></el-switch>
                    </div>
                  </div>
                </div>
                <div class="section-settings">
                  <div class="section-setting-item big">
                    <div class="setting-icon">
                      <div class="setting-icon-box">
                        <i class="fas fa-globe-americas"></i>
                      </div>
                    </div>
                    <div class="setting-title">
                      {{ $t("account_settings.account.language") }}
                    </div>
                    <div class="setting-info"></div>
                  </div>
                  <div class="section-setting-item">
                    <div class="setting-icon">
                      <div class="setting-icon-box clear">
                        <img src="/static/circle-flags_tr.svg" width="20px" height="20px" alt="Tr flag" />
                      </div>
                    </div>
                    <div class="setting-title" style="display:flex;gap:5px; align-items:center;">
                      <span>{{ $t("account_settings.account.tr") }}</span>
                    </div>
                    <div class="setting-info">
                      <div class="custom-radio-box" @click="$i18n.locale = 'tr'" :class="{ active: $i18n.locale == 'tr' }"></div>
                    </div>
                  </div>
                  <div class="section-setting-item">
                    <div class="setting-icon">
                      <div class="setting-icon-box clear">
                        <img src="/static/circle-flags_uk.svg" width="20px" height="20px" alt="UK flag" />
                      </div>
                    </div>
                    <div class="setting-title" style="display:flex;align-items:center;gap:5px;">
                      <span>{{ $t("account_settings.account.en") }}</span>
                    </div>
                    <div class="setting-info">
                      <div class="custom-radio-box" @click="$i18n.locale = 'en'" :class="{ active: $i18n.locale == 'en' }"></div>
                    </div>
                  </div>
                </div>
                <div class="section-settings">
                  <div class="section-setting-item big">
                    <div class="setting-icon">
                      <div class="setting-icon-box">
                        <i class="fas fa-user"></i>
                      </div>
                    </div>
                    <div class="setting-title">
                      {{ $t("account_settings.account.account_transactions") }}
                    </div>
                    <div class="setting-info"></div>
                  </div>
                  <div class="section-setting-item" @click="deleteAccountModal = true" style="cursor:pointer;">
                    <div class="setting-icon">
                      <div class="setting-icon-box">
                        <i class="fas fa-trash"></i>
                      </div>
                    </div>
                    <div class="setting-title">
                      <span>{{ $t("account_settings.account.delete_account") }}</span>
                    </div>
                    <div class="setting-info"></div>
                  </div>
                  <div class="section-setting-item" @click="logout" style="cursor:pointer;">
                    <div class="setting-icon">
                      <div class="setting-icon-box">
                        <i class="fas fa-sign-out-alt"></i>
                      </div>
                    </div>
                    <div class="setting-title">
                      <span>{{ $t("header.logout") }}</span>
                    </div>
                    <div class="setting-info"></div>
                  </div>
                </div>
              </div>
            </el-tab-pane>

            <el-tab-pane :label="$t('account_settings.password.title')" name="3">
              <div class="container-inner">
                <div class="info-card">
                  <i class="fa fa-lock"></i>
                  <span v-if="$store.state.user.passwordUpdateDate != null">
                    {{
                      $t("account_settings.password.description", {
                        date: $i18n.locale == "tr" ? moment(this.$store.state.user.updateDate).format("DD MMMM YYYY") : moment(this.$store.state.user.updateDate).format("LL")
                      })
                    }}
                  </span>
                  <span v-if="$store.state.user.passwordUpdateDate == null">
                    {{
                      $t("account_settings.password.never_updated_password", {
                        date: $i18n.locale == "tr" ? moment(this.$store.state.user.updateDate).format("DD MMMM YYYY") : moment(this.$store.state.user.updateDate).format("LL")
                      })
                    }}
                  </span>
                </div>

                <div class="custom-section-area mb">
                  <div class="custom-section-header">
                    <div class="custom-section-title">
                      <div class="custom-section-icon-box">
                        <div class="section-box-icon">
                          <i class="fas fa-briefcase"></i>
                        </div>
                      </div>
                      <span>{{ $t("account_settings.password.password_transactions") }}</span>
                    </div>
                  </div>
                  <div class="custom-section-body">
                    <div class="information-form">
                      <div class="information-form-input">
                        <label>{{ $t("password.currentPassword") }}</label>
                        <el-input placeholder="..." v-model="passform.password" :type="showPwd ? 'text' : 'password'">
                          <i slot="suffix" @click="showPwd = !showPwd" class="el-input__icon cpointer fas" :class="showPwd ? 'fa-eye' : 'fa-eye-slash'"></i>
                        </el-input>
                        <span class="text-danger">{{ $errorMessage("password", validationErrorsPass) }}</span>
                      </div>
                      <div class="information-form-input">
                        <label>{{ $t("password.newPassword") }}</label>
                        <el-input placeholder="..." v-model="passform.newPassword" :type="showPwd ? 'text' : 'password'">
                          <i slot="suffix" @click="showPwd = !showPwd" class="el-input__icon cpointer fas" :class="showPwd ? 'fa-eye' : 'fa-eye-slash'"></i>
                        </el-input>
                        <span class="text-danger">{{ $errorMessage("newPassword", validationErrorsPass) }}</span>
                      </div>
                      <div class="information-form-input">
                        <label>{{ $t("password.newPasswordRetry") }}</label>
                        <el-input placeholder="..." v-model="passform.newPasswordRetry" :type="showPwd ? 'text' : 'password'">
                          <i slot="suffix" @click="showPwd = !showPwd" class="el-input__icon cpointer fas" :class="showPwd ? 'fa-eye' : 'fa-eye-slash'"></i>
                        </el-input>
                        <span class="text-danger">{{ $errorMessage("newPasswordRetry", validationErrorsPass) }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="custom-section-footer">
                    <el-button type="primary" :loading="loading == 'changePassword'" :disabled="loading == 'changePassword'" @click="changePassword">{{ $t("save") }}</el-button>
                  </div>
                </div>
              </div>
            </el-tab-pane>
          </el-tabs>
        </el-row>
      </transition>

      <md-snackbar :class="response.hasError ? 'warning' : 'info'" :md-position="'center'" :md-duration="4000" :md-active.sync="snackbar.show" md-persistent>
        <i class="fa" :class="response.hasError ? 'fa-exclamation-triangle' : 'fa-user'"></i>
        <span>{{ snackbar.message }}</span>
      </md-snackbar>
    </div>
    <!-- <div class="modal-footer" slot="footer">
      <div class="left-buttons">
        <el-button @click="$emit('closeDialog')">Close</el-button>
      </div>
      <div class="right-buttons">
      </div>
    </div> -->
    <el-dialog :visible.sync="addJobModal" :close-on-click-modal="false" class="medium" :destroy-on-close="true" center append-to-body :title="$t('accountSettings.addJob')">
      <AddJob v-if="addJobModal" @closeDialog="addJobModal = false" @deleteMe="deleteJob" :id="addJobId" />
    </el-dialog>
    <el-dialog :visible.sync="addSchoolModal" :close-on-click-modal="false" class="medium" :destroy-on-close="true" center append-to-body :title="$t('accountSettings.addTutorial')">
      <AddSchool v-if="addSchoolModal" @closeDialog="addSchoolModal = false" @deleteMe="deleteSchool" :id="addSchoolId" />
    </el-dialog>
    <el-dialog :visible.sync="addLanguageModal" :close-on-click-modal="false" class="medium" :destroy-on-close="true" center append-to-body :title="$t('accountSettings.addLanguage')">
      <AddLanguage v-if="addLanguageModal" @closeDialog="addLanguageModal = false" @deleteMe="deleteLanguage" :id="addLanguageId" />
    </el-dialog>
    <el-dialog :visible.sync="deleteAccountModal" :close-on-click-modal="false" class="medium" :destroy-on-close="true" center append-to-body :title="$t('accountSettings.deleteAccount')">
      <DeleteAccount v-if="deleteAccountModal" @closeDialog="deleteAccountModal = false" />
    </el-dialog>
  </div>
</template>

<script>
import { mask } from "vue-the-mask";
import moment from "moment/min/moment-with-locales";
import axios from "axios";
import AddJob from "../components/account/AddJob.vue";
import AddSchool from "../components/account/AddSchool.vue";
import AddLanguage from "../components/account/AddLanguage.vue";
import DeleteAccount from "../components/account/DeleteAccount.vue";
export default {
  directives: { mask },
  name: "AccountSettings",
  components: {
    AddJob,
    AddSchool,
    AddLanguage,
    DeleteAccount
  },
  data() {
    return {
      moment,
      activeTab: "1",
      accountform: JSON.parse(JSON.stringify(this.$store.state.user)),
      profileform: JSON.parse(JSON.stringify(this.$store.state.user.contactInfo)),
      deleteAccountModal: false,
      addLanguageModal: false,
      addLanguageId: null,
      addJobModal: false,
      addJobId: null,
      addSchoolModal: false,
      addSchoolId: null,
      passform: {
        password: null,
        newPassword: null,
        newPasswordRetry: null
      },
      isLoading: false,
      isError: false,
      response: {
        hasError: false,
        message: null,
        validationErrors: []
      },
      file: null,
      fileUploading: false,
      snackbar: {
        show: false,
        message: null
      },
      loading: false,
      timeout: null,
      host: location.host == "localhost:3000" ? "https://live.holacon.com/" : "https://" + location.host,
      emailKey: null,
      phoneKey: null,
      confirmEmailForm: false,
      confirmPhoneForm: false,
      showPwd: false,
      addUpdateInterestForm: false,
      searchTerm: null,
      interests: [],
      validationErrors: [],
      validationErrorsPass: [],
      userInterests: JSON.parse(JSON.stringify(this.$store.state.user.interests))
    };
  },
  async created() {
    await this.$store.dispatch("getUserLanguages");
  },
  computed: {
    user() {
      return this.$store.getters.getUser;
    },
    innerWidth() {
      return window.innerWidth;
    }
  },

  methods: {
    openFileChanged() {
      this.$refs.file.click();
    },
    handleClick(tab, event) {},
    logout() {
      localStorage.removeItem("token");
      localStorage.removeItem("lastApplication");
      axios.defaults.headers["Authorization"] = null;
      this.$store.state.token = null;
      this.$store.state.user = null;
      this.$router.push({ name: "login" });
      window.location.reload(true); //TODO: Sayfayı yenilemediğimizde farklı accountların bilgileri store da kalıyor.
    },
    saveProfile() {
      this.loading = "saveProfile";
      var cellPhone = null;
      var phone = null;
      if (this.$refs.contactPhoneInput.phoneFormatted != null) {
        phone = this.$refs.contactPhoneInput.phoneFormatted.replaceAll(" ", "");
      }
      if (this.$refs.contactCellPhoneInput.phoneFormatted != null) {
        cellPhone = this.$refs.contactCellPhoneInput.phoneFormatted.replaceAll(" ", "");
      }
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        var res = await axios.post("account/updatecontactinfo", {
          contactInfo: {
            ...this.profileform,
            phone: phone,
            cellPhone: cellPhone
          }
        });
        this.validationErrors = res.data.validationErrors;
        if (!res.data.hasError) {
          this.$store.state.user.contactInfo = this.profileform;
          this.$message.success(res.data.message);
        } else {
          this.$message.error(res.data.message);
        }
        this.loading = false;
      }, 500);
    },
    async toggleNotification() {
      var payload = {
        peopleNotifications: this.user.peopleNotifications,
        messageNotifications: this.user.messageNotifications,
        eventNotifications: this.user.eventNotifications
      };
      await this.$store.dispatch("toggleAccountNotifications", payload);
    },
    async toggleAccountVisible() {
      var payload = {
        showMeOnAPP: this.accountform.showMeOnAPP,
        showMeBusy: this.accountform.showMeBusy,
        showConnectedAccount: this.accountform.showConnectedAccount
      };
      var res = await axios.post("/Account/UpdateAccountGeneralSettings", payload);
      if (res.data.hasError) {
        this.$message.error(res.data.message);
      } else {
        await this.$store.dispatch('getUser');
        this.$message.success(res.data.message);
      }
    },
    async saveAccount() {
      this.loading = "saveAccount";

      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        var res = await this.$store.dispatch("updateAccountProfile", {
          ...this.accountform,
          phoneNumber: this.$refs.phoneInput2.phoneFormatted != null ? this.$refs.phoneInput2.phoneFormatted.replace(/\s/g, "") : null
        });
        if (!res.data.hasError) {
          var response = await axios.post("account/get");
          this.$store.commit("setUser", response.data.data.user);
          this.$store.commit("setNotify", response.data.data);
          this.confirmEmailForm = false;
          this.confirmPhoneForm = false;
          this.phoneKey = null;
          this.emailKey = null;
        }
        this.loading = false;
      }, 500);
    },

    async changePassword() {
      this.loading = "changePassword";
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        var res = await this.$store.dispatch("changePassword", this.passform);
        this.validationErrorsPass = res.data.validationErrors;
        this.loading = false;
      }, 500);
    },

    hasError(key) {
      if (this.response.validationErrors.some(k => k.key == key)) {
        return "md-invalid";
      } else {
        return "";
      }
    },

    errorMessage(key) {
      if (this.response.validationErrors.some(k => k.key == key)) {
        return this.response.validationErrors.find(k => k.key == key).value;
      } else {
        return "";
      }
    },
    filePicked() {
      this.fileUploading = true;
      this.file = this.$refs.file.files[0];
      let formData = new FormData();
      formData.append("file", this.file);
      axios.post("account/uploadfile?uploadType=profilePicture", formData).then(res => {
        if (res.data.hasError) {
          this.$message.error(res.data.message);
        } else {
          this.$message.success(res.data.message);
          this.accountform.image = res.data.data.item.url;
          this.saveAccount();
        }
        this.fileUploading = false;
      });
    },

    async sendPhoneCode() {
      var res = await axios.post("account/confirm", { type: 2, key: null, isLive: true });
      if (!res.data.hasError) {
        this.confirmPhoneForm = true;
        this.$message.success(res.data.message);
      } else {
        this.$message.error(res.data.message);
      }
    },

    sendEmailCode() {
      axios.post("account/confirm", { type: 1, key: null, isLive: true }).then(res => {
        this.snackbar = {
          show: true,
          message: res.data.message
        };

        this.confirmEmailForm = true;
      });
    },

    async confirmPhone() {
      var res = await axios.post("account/confirm", { type: 2, key: this.phoneKey });
      if (res.data.hasError == false) {
        var response = await axios.post("account/get");
        this.$store.commit("setUser", response.data.data.user);
        this.$store.commit("setNotify", response.data.data);
        this.$store.state.user.phoneNumberConfirmed = true;
        this.confirmPhoneForm = false;
        this.$message.success(res.data.message);
      } else {
        this.$message.error(res.data.message);
      }
    },

    async confirmEmail() {
      axios.post("account/confirm", { type: 1, key: this.emailKey }).then(async res => {
        if (res.data.hasError == false) {
          var response = await axios.post("account/get");
          this.$store.commit("setUser", response.data.data.user);
          this.$store.commit("setNotify", response.data.data);
          this.confirmEmailForm = false;
          this.$message.success(res.data.message);
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    async deleteJob(id) {
      var res = await this.$store.dispatch("removeAccountJob", id);
      if (!res.data.hasError) {
        var fIndex = this.$store.state.user.jobs.findIndex(x => x.id == id);
        if (fIndex != -1) {
          this.$store.state.user.jobs.splice(fIndex, 1);
          this.jobs.splice(fIndex, 1);
        }
      }
    },

    async deleteSchool(id) {
      var res = await this.$store.dispatch("removeAccountSchool", id);
      if (!res.data.hasError) {
        var fIndex = this.$store.state.user.schools.findIndex(x => x.id == id);
        if (fIndex != -1) {
          this.$store.state.user.schools.splice(fIndex, 1);
        }
      }
    },
    async deleteLanguage(id) {
      var res = await this.$store.dispatch("removeAccountLanguage", id);
      if (!res.data.hasError) {
        var fIndex = this.$store.state.user.languages.findIndex(x => x.id == id);
        if (fIndex != -1) {
          this.$store.state.user.languages.splice(fIndex, 1);
        }
      }
    },
    async searchInterest() {
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        var res = await axios.post("/Definition/SearchInterests", {
          searchTerm: this.searchTerm,
          skip: 0,
          take: 10
        });

        this.interests = res.data.data.items;
      }, 500);
      setTimeout(() => {}, 780);
    },

    toggleInterest(interest) {
      var index = this.userInterests.findIndex(k => k == interest.title);
      if (index == -1) {
        axios.post("account/addinterest", { title: interest.title });
        this.userInterests.push(interest.title);
        this.$store.state.user.interests.push(interest.title);
      } else {
        axios.post("account/removeinterest", { title: interest.title });
        this.userInterests.splice(index, 1);
        this.$store.state.user.interests.splice(index, 1);
      }
    }
  },

  watch: {
    searchTerm: async function() {
      await this.searchInterest();
    },
    "$i18n.locale": function(newVal, oldVal) {
      moment.locale(newVal);
      localStorage.setItem("lang", newVal);

      this.accountform.languageCode = newVal;
      this.saveAccount();
      this.$nextTick(() => {
        window.location.reload();
      });
    }
  }
};
</script>

<style lang="less">
#account-dialog {
  width: 100%;

  .info-card {
    display: flex;
    flex: 1;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    margin-bottom: 20px;
    background-color: #fbfbfb;
    padding: 10px 12px;
    border: 0.5px solid #d6d9d9;
    border-radius: 8px;
    word-break: break-word;
    @media screen and (max-width: 768px) {
      flex-direction: column;
      justify-content: unset;
      align-items: center;
      gap: 0.5rem;
    }

    i {
      width: 50px;
      height: 50px;
      background: white;
      border: 5px solid #d6d9d9;
      border-radius: 50%;
      line-height: 0.7;
      font-size: 26px;
      color: #268ea6;
      display: inline-flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }

    span {
      width: 100%;
      padding-left: 10px;
      max-width: calc(~"100% - 70px");
      margin: 0px;
      color: #505763;
      font-size: 13px;
      @media screen and (max-width: 768px) {
        max-width: 100%;
        text-align: center;
      }
    }
  }

  .container-inner {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;
    padding: 0px 10px;
    margin: 0px;

    .profile-picture-container {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-start;
      width: 100%;

      .profile-picture {
        width: 160px;
        height: 160px;
        background-size: cover;
        border-radius: 50%;
        border: 10px solid #f1f1f1;
        cursor: pointer;
      }

      label {
        cursor: pointer;
        color: #505763;
        font-size: 14px;
        display: flex;
        flex-direction: column-reverse;
        justify-content: center;
        align-items: center;

        i {
          width: 30px;
          height: 30px;
          background: #268ea6;
          border-radius: 50%;
          line-height: 0.7;
          padding: 11px 8px;
          font-size: 14px;
          color: white;
          margin-bottom: 5px;
          margin-top: -14px;
        }

        input {
          display: none;
        }
      }
    }

    .account-confirmation-section {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      background: #f6f6f6;
      padding: 16px 12px 16px 12px;
      margin-top: 0px;
      margin-bottom: 16px;
      border-radius: 8px;
      gap: 1rem;

      .el-form-item {
        width: 100%;
      }
      .el-input {
        width: 100%;
      }
      .information-form-input {
        gap: 0;
      }
      .el-button {
        align-self: flex-end;
      }
    }

    .section-title {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      width: 100%;
      padding: 16px 6px 10px 6px;

      span {
        color: #505763;
        font-weight: 500;
        font-size: 14px;
      }
    }
    .custom-section-area {
      &.mb {
        margin-bottom: 0.5rem;
      }
      width: 100%;
      background-color: white;
      box-shadow: 0px 2px 10px rgba(41, 47, 59, 0.1);
      border-radius: 16px;
      padding: 10px;
      display: flex;
      flex-direction: column;
      margin-top: 1rem;
      gap: 10px;
      .custom-section-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
      .custom-section-title {
        display: flex;
        flex-direction: row;
        gap: 10px;
        align-items: center;
        .custom-section-icon-box {
          width: 36px;
          height: 36px;
          border-radius: 50%;
          background-color: #f1f3f6;
          display: flex;
          align-items: center;
          justify-content: center;
          .section-box-icon {
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 50%;
            width: 24px;
            i {
              font-size: 18px;
              color: #268ea6 !important;
            }
            height: 24px;
          }
        }
        span {
          font-weight: bold;
          font-size: 14px;
        }
      }

      .custom-section-footer {
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }

    .section-settings {
      width: 100%;
      position: relative;
      margin: 8px;
      margin-top: 20px;

      border-radius: 8px;
      padding: 10px;
      background-color: white;
      display: flex;
      box-shadow: 0px 2px 10px rgba(41, 47, 59, 0.1);
      flex-direction: column;
      gap: 20px;
      &::after {
        display: block;
        content: " ";
        width: 2px;
        background-color: rgb(233, 233, 233);
        position: absolute;
        height: calc(~"100% - 20px");
        top: 10px;
        left: 34px;
        z-index: 1;
      }

      .section-setting-item {
        width: 100%;
        display: grid;
        align-items: center;
        grid-template-columns: 48px 1fr 48px;
        gap: 10px;
        .setting-icon {
          z-index: 2;
          width: 100%;
          font-size: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .setting-icon-box {
          color: white;
          font-weight: bold;
          width: 24px;
          height: 24px;
          border-radius: 50%;
          border: 2px solid #f1f3f6;
          padding: 2px;
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: #268ea6;
          &.clear {
            background-color: #ffffff;
          }
        }
        &.big {
          .setting-title {
            font-weight: bold;
            font-size: 18px;
          }
          .setting-icon-box {
            width: 36px;
            height: 36px;
            font-size: 18px;
          }
        }
      }
    }
    .section-container {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
      width: 100%;
      background-color: #f6f6f6;
      border-radius: 8px;
      padding: 14px;

      .custom-switch-row {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        min-height: 52px;

        &.clickable {
          cursor: pointer;
        }

        &.disabled {
          opacity: 0.5;
          filter: grayscale(100%);
          cursor: not-allowed !important;
          cursor: no-drop !important;
        }

        .row-left {
          flex-direction: row;
          align-items: center;
          justify-content: flex-start;
          i {
            width: 30px;
            height: 30px;
            background: #268ea6;
            border-radius: 50%;
            line-height: 0.7;
            padding: 11px 8px;
            font-size: 14px;
            color: white;
            display: inline-flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
          }

          span {
            color: #505763;
            font-weight: 500;
            font-size: 14px;
            margin-left: 6px;
          }
        }

        .row-right {
          i {
            color: #d6d9d9;
          }
        }
      }
    }

    .custom-input {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      width: 100%;
      margin-top: 12px;

      &.md-invalid {
        input {
          border-color: #f22f2f;
        }
      }

      label {
        color: #505763;
        font-weight: 500;
        font-size: 14px;
        margin-bottom: 6px;
      }

      input {
        width: 100%;
        border: 0;
        height: 40px;
        border-radius: 8px;
        outline: none;
        padding: 8px 12px;
        box-sizing: border-box;
        border: 0.5px solid #d6d9d9;
        background: #fbfbfb;
        height: 48px;
      }

      textarea {
        width: 100% !important;
        border: 0;
        height: 100px !important;
        border-radius: 8px;
        outline: none;
        padding: 8px 12px;
        box-sizing: border-box;
        border: 0.5px solid #d6d9d9;
        background: #fbfbfb;
        font-family: "Roboto", sans-serif;
        font-size: 13px;
      }

      span {
        font-size: 13px;
        color: #f22f2f;
        margin-top: 3px;
      }

      &.phone {
        .vue-phone-number-input {
          width: 100%;
        }

        .country-selector__country-flag {
          top: 18px;
        }

        .country-selector__input {
          border-radius: 8px 0px 0px 8px !important;
          border: 0.5px solid #d6d9d9 !important;
          box-shadow: none !important;
          padding-left: 40px;
        }

        .input-tel__input {
          border-radius: 0px 8px 8px 0px !important;
          border: 0.5px solid #d6d9d9 !important;
          box-shadow: none !important;
        }

        .country-selector__label {
          display: none;
        }

        .input-tel__label {
          display: none;
        }
      }
    }

    .form-confirm {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      padding: 20px;
      width: 100%;
    }

    .add-panel-container {
      background-color: #f6f6f6 !important;
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-start;
      padding: 15px 25px;
      border-radius: 8px;
      position: relative;

      &::after {
        content: "";
        position: absolute;
        bottom: 0;
        left: 50%;
        width: 0;
        height: 0;
        border: 24px solid transparent;
        border-top-color: #f6f6f6;
        border-bottom: 0;
        margin-left: -22px;
        margin-bottom: -16px;
      }

      .custom-add-button {
        margin: 0;
        width: 100%;
        margin-bottom: 20px;
        border-radius: 8px;
      }
    }

    .custom-card {
      margin-bottom: 8px;
      background: #f1f3f6;
      border-radius: 12px;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 4px 10px;

      .action {
        padding: 20px;
        cursor: pointer;
      }

      .md-card-header {
        padding: 0px;
        align-items: center;
      }

      .custom-card-header {
        padding: 8px 12px !important;

        .md-title {
          font-weight: 500;
          color: #292f3b;
        }

        .md-subhead {
          color: #505763;
          &.bold {
            font-weight: 500;
          }
        }
      }
    }

    .chips-container {
      display: flex;
      flex-direction: row;
      gap: 10px;
      flex-wrap: wrap;
    }

    .md-chip {
      margin: 4px;
      overflow: hidden;
    }
  }
}

.custom-accountsettings-dialog {
  .md-dialog-container {
    max-height: calc(~"100vh - 100px");
    max-width: 520px;
  }
}
.custom-radio-box {
  width: 20px;
  height: 20px;
  border: 2px solid #ccc;
  cursor: pointer;
  border-radius: 50%;
  padding: 2px;

  &.active {
    border: 2px solid #268ea6;
    &::before {
      content: " ";
      display: block;
      border-radius: 50%;
      background-color: #268ea6;
      width: 100%;
      height: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/AccountSettings.vue